// extracted by mini-css-extract-plugin
export default {"AwesomeRwdMenu":"AwesomeRwdMenu_AwesomeRwdMenu__HY1C0"};